import React, { useContext, useEffect, useState } from "react";
import {
    Button,
    ButtonBase,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
import { useStores } from "../../../../../hooks";
import { Space, Typography } from "../../../../../common/components/libs";
import CachedIcon from "@material-ui/icons/Cached";
import { observer } from "mobx-react";
import { SnackbarType } from "../../../../../stores/common";

import classes from "./updateChatFormStyle.module.css"
import OrderSettingsPageStoreContext from "../context";
import { getMenuById, getTelegramReportingBindingUrl } from "../../../../../services/menu";
import { useTranslation } from "react-i18next";
import { MenuType } from "../../../../../services/menu/models";


const UpdateChatForm = () => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const {t} = useTranslation(["general", "menu"]);
    const { generalMenuStore, generalStore } = useStores();

    const store = useContext(OrderSettingsPageStoreContext);
    const current = store.current;
    const open = store.forms.updateChatFormOpen;

    const [previousReporting, setPreviousReporting] = useState([]);
    const [isActiveCard, setActiveCard] = useState(false);
    const [urls, setUrls] = useState({
        privateMessages: undefined,
        group: undefined
    })

    useEffect(() => {
        if(open){
            getTelegramReportingBindingUrl({
                menuId: store.current.id,
            }).then((response) => {
                setUrls({
                    privateMessages: response.bindToPrivateMessagesUrl,
                    group: response.bindToGroupUrl,
                })
            })

        }
    }, [open]);

    const closeForm = async () => {
        await generalMenuStore.fetchMenus(MenuType.regular);
        await generalMenuStore.fetchMenus(MenuType.booking);
        store.closeUpdateChatForm();
    };

    const checkConnection = async () => {
        const response = await getMenuById({
            menuId: store.current.id
        });
        const menu = response.menu;
        if (
            previousReporting.length + 1 ===
            menu.data.reporting.destinations.length
        ) {
            generalStore.showSnackbar({
                title: t("menu:orderSettingsPage.notificationsConnected"),
                type: SnackbarType.success
            });
            store.setReportingDestinations(menu.data.reporting.destinations);
            await closeForm();
        } else {
            generalStore.showSnackbar({
                title: t("menu:orderSettingsPage.notificationsNotConnected"),
                description: t("menu:orderSettingsPage.tryTuneAgain"),
                type: SnackbarType.error
            });
        }
    };

    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title">
                {t("menu:orderSettingsPage.addChatForNotifications")}
            </DialogTitle>
            <DialogContent>
                <Grid container direction="column">
                    <Grid
                        item
                        className={isActiveCard ? classes.cardActive : classes.card}
                    >
                        <ButtonBase
                            focusRipple
                            style={{ textAlign: "left" }}
                            onClick={() => {
                                setActiveCard(true);
                            }}
                        >
                            <Grid item >
                                <div className={classes.content}>
                                    <Typography variant="h6">{t("menu:orderSettingsPage.group")}</Typography>
                                    <Typography variant="body2" color='textSecondary'>
                                        {t("menu:orderSettingsPage.groupDescription")}
                                    </Typography>
                                </div>
                                <Grid
                                    container
                                    className={isActiveCard ? null : classes.hideButtons}
                                >
                                    <Grid item xs={12} sm={3}>
                                        <Button
                                            color="primary"
                                            size="large"
                                            target="_blank"
                                            variant={'contained'}
                                            fullWidth
                                            href={urls.group}
                                            onClick={() => {
                                                setPreviousReporting(current.data.reporting.destinations);
                                            }}
                                        >
                                            {t("menu:orderSettingsPage.chooseGroup")}
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm>
                                        <Button
                                            color="primary"
                                            size="large"
                                            onClick={checkConnection}
                                        >
                                            <CachedIcon className={classes.icon}/>
                                            {t("menu:orderSettingsPage.checkConnection")}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ButtonBase>
                    </Grid>
                    <Space size={5}/>
                    <Grid
                        item
                        className={isActiveCard ? classes.card : classes.cardActive}
                    >
                        <ButtonBase
                            focusRipple
                            style={{ textAlign: "left" }}
                            onClick={() => {
                                setActiveCard(false);
                            }}
                        >
                            <Grid item>
                                <div className={classes.content}>
                                    <Typography variant="h6">Личные сообщения</Typography>
                                    <Typography variant="body2"  color='textSecondary'>
                                        {t("menu:orderSettingsPage.privateChatDescription")}
                                    </Typography>
                                </div>
                                <Grid
                                    container
                                    spacing={0}
                                    className={isActiveCard ? classes.hideButtons : null}
                                >
                                    <Grid item xs={12} sm={3}>
                                        <Button
                                            variant={'contained'}
                                            fullWidth
                                            color="primary"
                                            size="large"
                                            target="_blank"
                                            href={urls.privateMessages}
                                            onClick={() => setPreviousReporting(current.data.reporting.destinations)}
                                        >
                                            {t("general:add")}
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm alignItems="center">
                                        <Button
                                            color="primary"
                                            size="large"
                                            onClick={checkConnection}
                                        >
                                            <CachedIcon className={classes.icon}/>
                                            {t("menu:orderSettingsPage.checkConnection")}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ButtonBase>
                    </Grid>
                    <Space size={10}/>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color='primary' variant='contained'
                        onClick={closeForm}>
                    {t("general:close")}
                </Button>

            </DialogActions>
        </Dialog>
    );
};
export default observer(UpdateChatForm);
